export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MenuItem.vue?vue&type=template&id=e06f1b0a&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/MenuItem.vue?vue&type=template&id=e06f1b0a&scoped=true
// module id = 72
// module chunks = 0